import React from 'react';
import { Button as MuiButton, ButtonProps } from '@mui/material';

export default function Button(props: ButtonProps | any) {
    return <MuiButton disableElevation {...props} />
}